import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

// Fetches page metadata for a URL entered into the url field and prefills
// the title, description, and image URL fields. Fields the user has already
// filled in are never overwritten.
export default class extends Controller {
  static targets = ["url", "title", "description", "imageUrl", "spinner"]
  static values = { endpoint: String }

  // The paste event fires before the field value updates, so defer a tick.
  paste() {
    setTimeout(() => this.fetch(), 0)
  }

  async fetch() {
    const url = this.urlTarget.value.trim()
    if (!url || url === this.lastRequestedUrl) return
    if (this.titleTarget.value && this.descriptionTarget.value && this.imageUrlTarget.value) return
    this.lastRequestedUrl = url

    this.urlTarget.disabled = true
    this.spinnerTarget.classList.remove("d-none")
    try {
      const response = await fetch(this.endpointValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({ url })
      })
      if (!response.ok) {
        const body = await response.json().catch(() => ({}))
        this.toast(body.error || "Couldn't fetch a preview for that URL.")
        return
      }

      const metadata = await response.json()
      this.fill(this.titleTarget, metadata.title)
      this.fill(this.descriptionTarget, metadata.description)
      this.fill(this.imageUrlTarget, metadata.image_url)
    } catch {
      this.toast("Couldn't fetch a preview for that URL.")
    } finally {
      this.urlTarget.disabled = false
      this.spinnerTarget.classList.add("d-none")
    }
  }

  fill(target, value) {
    if (value && !target.value) target.value = value
  }

  toast(message) {
    const element = document.createElement("div")
    element.className = "toast align-items-center text-bg-danger border-0"
    element.setAttribute("role", "alert")
    element.setAttribute("aria-live", "assertive")
    element.setAttribute("aria-atomic", "true")
    element.innerHTML = `
      <div class="d-flex">
        <div class="toast-body"></div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>`
    element.querySelector(".toast-body").textContent = message

    this.toastContainer().appendChild(element)
    element.addEventListener("hidden.bs.toast", () => element.remove())
    new Toast(element, { delay: 5000 }).show()
  }

  toastContainer() {
    let container = document.querySelector(".toast-container")
    if (!container) {
      container = document.createElement("div")
      container.className = "toast-container position-fixed bottom-0 end-0 p-3"
      document.body.appendChild(container)
    }
    return container
  }
}
